export default {
    filter: ({ filter }) => filter,
    title: ({ title }) => title,
    titleShort: ({ titleShort }) => titleShort
};
